import { render, staticRenderFns } from "./EditButtonGroup.vue?vue&type=template&id=15e16cde&scoped=true&"
import script from "./EditButtonGroup.vue?vue&type=script&lang=js&"
export * from "./EditButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e16cde",
  null
  
)

export default component.exports